import * as React from 'react';
import useAuth from '@/auth/use-auth';

import './UiPhone.scss';

type UiPhoneProps = {
  onSubmit: (phone: string) => void;
};

const UiPhone = ({ onSubmit }: UiPhoneProps) => {
  const { signIn } = useAuth();
  const inputRef = React.useRef<HTMLInputElement>(null);

  const prefixNumber = (str: string): string => {
    switch (str) {
      case '8':
        return '8 (';
      case '9':
        return '7 (9';
      default:
        return '7 (';
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!inputRef.current) return;

    let valueRaw = event.target.value;
    if (valueRaw === '8 ' || valueRaw === '') {
      inputRef.current.value = '';
      return;
    } else if (valueRaw.length === 3 && valueRaw.endsWith(' ')) {
      inputRef.current.value = '+';
      return;
    }
    const value = valueRaw.replace(/\D+/g, '');
    const numberLength = 11;
    let result = valueRaw.includes('+8') || valueRaw.startsWith('8') ? '' : '+';

    for (let i = 0; i < value.length && i < numberLength; i++) {
      switch (i) {
        case 0:
          result += prefixNumber(value[i]);
          // eslint-disable-next-line no-continue
          continue;
        case 4:
          result += ') ';
          break;
        case 7:
          result += '-';
          break;
        case 9:
          result += '-';
          break;
        default:
          break;
      }
      result += value[i];
    }

    inputRef.current.value = result;
    inputRef.current.className = `phone ${value.length === 11 ? ' valid' : ''}`;
  };

  const handleSignIn = async () => {
    const phone = inputRef.current?.value ?? '';
    await signIn(phone);
    onSubmit(phone);
  };

  return (
    <div className="form-group">
      <label htmlFor="user-phone" className="form-label" data-testid="title">
        Введите номер телефона:
      </label>
      <input
        id="user-phone"
        ref={inputRef}
        type="tel"
        className="phone index-element-1"
        placeholder="+7 (000) 000-00-00"
        maxLength={18}
        onChange={handleChange}
        data-testid="phone"
      />
      <span className="button">
        <button
          type="button"
          className="btn index-element-2"
          onClick={handleSignIn}
          data-testid="next"
        >
          Продолжить
        </button>
      </span>
    </div>
  );
};

export default UiPhone;
